import $ from 'jquery'
import ReportEditConfigController from './ATReportEditConfigController'
import BudgetGroupingSelector from '../BudgetGroupingSelector'
import {ReportGroupingLevel} from '../constants'

export default class BudgetedVsActualReportEditConfigController extends ReportEditConfigController {}

BudgetedVsActualReportEditConfigController.prototype.init = function ( config )
{
    ReportEditConfigController.prototype.init.call(this, config);

    const reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters)
    this.configChangedCallback = config.changeCallback
    const configChanged = () => this.configChanged()

    this.timeFormatSelector = this.initTimeFormatSelector( reportParameters.timeFormat, configChanged);

    const groupingLevelsSelection = [
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.thirdGroupingLevel,
        reportParameters.fourthGroupingLevel,
    ]

    this.groupingSelector = new BudgetGroupingSelector().init(
        "reportGroupingSelector",
        groupingLevelsSelection,
        EnabledFeatures.BTY || this.checkGroupingLevel(ReportGroupingLevel.BILLING_TYPE, groupingLevelsSelection),
        () => {
            this.removeGroupingLevelsSelectionError()
            configChanged()
        },
    )

    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);

    this.reportAuthorizationInfo = config.reportAuthorizationInfo

    this.taskRadioGroupSelector = this.initRadioGroupSelector("taskBudgetActualRadioGroupsSelector", "tasksOption",  reportParameters.tasksConfig, configChanged);
    this.includeNotStartedTasks_checkbox = $("#includeNotStartedTasks_checkbox").prop("checked", reportParameters.includeNotStarted).on("change", configChanged);
    this.includeNotBudgetedTasks_checkbox = $("#includeNotBudgetedTasks_checkbox").prop("checked", reportParameters.includeNotEstimated).on("change", configChanged);
    return this;
};

BudgetedVsActualReportEditConfigController.prototype.getConfig = function () {
    const groupingLevelValues = this.groupingSelector.getValues()
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        tasksConfig: this.taskRadioGroupSelector.getValue(),
        includeNotStarted : this.includeNotStartedTasks_checkbox.is(":checked"),
        includeNotEstimated : this.includeNotBudgetedTasks_checkbox.is(":checked"),
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        fourthGroupingLevel: groupingLevelValues[3],
        reportAuthorizationInfo: this.reportAuthorizationInfo,
    };
};

BudgetedVsActualReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.taskRadioGroupSelector.setItemByValue(this.initReportParameters.tasksConfig);
    this.includeNotStartedTasks_checkbox.prop("checked", this.initReportParameters.includeNotStarted);
    this.includeNotBudgetedTasks_checkbox.prop("checked", this.initReportParameters.includeNotEstimated);
    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel,
        this.initReportParameters.secondGroupingLevel,
        this.initReportParameters.thirdGroupingLevel,
        this.initReportParameters.fourthGroupingLevel ]);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
};

BudgetedVsActualReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    ReportEditConfigController.prototype.setSelectorsInitStateFromCurrent.call(this);

    if(this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};

BudgetedVsActualReportEditConfigController.prototype.validate = function()
{
    this.errors = [];

    if (!this.cpSelector.checkSelected())
        this.errors.push( this.possibleErrors.ERROR_EMPTY_CP_SELECTION );

    if (!this.groupingSelector.validate())
        this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0
};

BudgetedVsActualReportEditConfigController.prototype.initErrorsToSectionElsMap = function()
{
    let errorsToSectionElsMap = {}
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find( "#cpSelectorId" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find( ".reportGroupingSelectorContainer" );
    return errorsToSectionElsMap;
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/BudgetedVsActualReportEditConfigController.js